/**
 * Utilities for rendering PHI-masked field values.
 *
 * When the backend masks a PHI field it returns null for the value and lists
 * the field name in phi_masked_fields. Use isPhiMasked() to detect this, then
 * phiMask() to get the display string.
 *
 * Default mask length is 8 asterisks. Fields with a known fixed display width
 * (e.g. SSN, date of birth) use a length that matches their normal format.
 */

const PHI_FIELD_LENGTHS = {
  billing_tin: 10,   // XX-XXXXXXX
  ssn: 11,           // XXX-XX-XXXX
  date_of_birth: 10, // YYYY-MM-DD
  dob: 10,

  birth_date: 10,    // YYYY-MM-DD (referral identifiers crosswalk)
};

const DEFAULT_MASK_LENGTH = 8;

function phiMask(fieldName) {
  const length = PHI_FIELD_LENGTHS[fieldName] ?? DEFAULT_MASK_LENGTH;
  return '*'.repeat(length);
}

function isPhiMasked(fieldName, phiMaskedFields) {
  return Array.isArray(phiMaskedFields) && phiMaskedFields.includes(fieldName);
}

export { phiMask, isPhiMasked };
